import { useState, useMemo } from 'react';

export const debounce = (callback, delay) => {
  let timeout;

  return (...args) => {
    if (timeout) {
      clearTimeout(timeout);
      timeout = undefined;
    }
    timeout = setTimeout(() => callback(...args), delay);
  };
};

const useDebounceValue = (initialValue, delay = 500) => {
  const [state, setState] = useState(initialValue);

  const debouncedSetState = useMemo(
    () =>
      debounce(value => {
        setState(value);
      }, delay),
    [delay],
  );

  return [state, debouncedSetState];
};

export default useDebounceValue;
